import $ from 'jquery';
import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';

const RestRelatoriosExpressNfePost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = (Arr_.dest ?? '')
    .toString()
    .replace(/[\s\u200B-\u200D\uFEFF\u0000]/g, '')
    .trim();

  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];
  $.ajaxSetup({headers: {Authorization: 'Bearer ' + token}});

  if (/^expressNfseGrupo\d{2}$/.test(caminho)) {
    return new Promise(function (resolve, reject) {
      const {dataPost} = JSON.parse(config.data);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Post',
          dataType: 'json',
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode(caminho),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err + ' Server Error'}]);
      }
    });
  }

  switch (caminho) {
    case 'expressGetColunas':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressGetModelos':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressSaveModelo':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressListagemNfeCompleta':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
      
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressListagemProdutosPeriodo':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressListagemParticipantes':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressTotaisPorFornecedor':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressTotaisPorNCM':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressTotaisImpostos':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressTotaisNovosImpostos':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNovosImpostosDetalhado':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNfeCanceladas':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNfeDenegadas':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNfeFinalidades':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressMatrizComplexidadeFiscalNfeRecebidas':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnalisarMatrizComplexidadeFiscalIa':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnalisarRankingPrazosFornecedorIa':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnalisarFlagsDifalIa':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnalisarFlagsFcpIa':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnalisarCfopIa':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnalisarNcmCfopCruzadoIa':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnalisarEvolucaoComprasMensalIa':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnalisarListagemNfeCompletaIa':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnalisarListagemProdutosIa':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnalisarTotaisImpostosIa':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnalisarNovosImpostosDetalhadoIa':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnalisarNfeFinalidadesIa':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressRankingPrazosFornecedor':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressListagemPagamentos':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressDuplicatasVencer':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressDuplicatasProximos30Dias':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressFaturasAnalise':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNfeComDifal':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNfeComFcp':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNfeMedicamentos':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNfeCombustiveis':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNfeVeiculos':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNfeExportacao':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNfeImportacao':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnaliseCfop':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnaliseCstIcms':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressAnaliseCstPisCofins':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNcmCfopCruzado':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNfePorUfOrigem':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressNfePorUfDestino':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressFluxoInterestadual':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressCceListagem':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    case 'expressGetQuotaIa':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];

        try {
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    default:
      return [200, {erro: `Relatório não configurado no fluxo (dest: ${caminho})`}];
  }
};

export {RestRelatoriosExpressNfePost};
